const useType = [
  { text: "工事", value: "1construction" },
  { text: "査定", value: "2assessment" },
  { text: "メンテ", value: "3maintenance" },
  { text: "ドローン", value: "4drone" },
];

export const getUseTypeString = (value) => {
  return useType.find(x => x.value === value).text;
}

export const getBlockTitle = (block) => {
  return `【${getUseTypeString(block.use_type)}】${block.name}`;
}
